import React, { VFC, ReactNode } from 'react';
import { styled as muiStyled } from '@mui/material/styles';
import MuiDialog, { DialogProps } from '@mui/material/Dialog';

interface Props extends DialogProps {
  children: ReactNode;
}
// 💡横幅を調整する場合は、PaperProps の style を使用する
// <Dialog PaperProps={{ style: { maxWidth: 700 } }}>
const Dialog: VFC<Props> = ({ children, ...rest }: Props) => {
  return <StyledDialog {...rest}>{children}</StyledDialog>;
};

const StyledDialog = muiStyled(MuiDialog)(
  ({ theme }) => `
  .MuiDialog-paper {
    width: 100%;
    margin: ${theme.spacing(0, 2)};
  }
`,
);
export default Dialog;
